import { RouteObject } from "react-router-dom";
import { AllTokens } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import {
  HISTORICAL_DATA_IMPORT_LIST_PATH,
  HistoricalDataImportListPage,
} from "./pages/historical-data-import";

export const historicalImportDataRoutes: RouteObject[] = [
  {
    path: HISTORICAL_DATA_IMPORT_LIST_PATH,
    element: (
      <Guard.Redirect.IfCantModify.PageNotFound
        influencedBy={[AllTokens.AdminCompanyImport]}
      >
        <HistoricalDataImportListPage />
      </Guard.Redirect.IfCantModify.PageNotFound>
    ),
  },
];
